export default __webpack_public_path__ + "static/visually-appealing-mobile-1-b31affb2caf49e39771308aee52ac596.webp";